
import { interpolate, toText } from "../fable_modules/fable-library-js.5.0.0-alpha.22/String.js";
import { AusdruckModule_get, Ausdruck, AusdruckModule_ofInt } from "./Ausdruck.jsx";
import { Record } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Types.js";
import { record_type, int32_type } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Reflection.js";
import { equals, Exception } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Util.js";
import { op_Division } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Decimal.js";
import Decimal from "../fable_modules/fable-library-js.5.0.0-alpha.22/Decimal.js";
import { find, reduce, empty, truncate, filter, length, item, ofArray } from "../fable_modules/fable-library-js.5.0.0-alpha.22/List.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Option.js";
import { Editable$2, Editable$2_$reflection, IntInput_$reflection } from "./Input.jsx";

export class Bruch extends Record {
    constructor(Zähler, Nenner) {
        super();
        this.Zähler = (Zähler | 0);
        this.Nenner = (Nenner | 0);
    }
    toString() {
        const this$ = this;
        return toText(interpolate("%d%P()/%d%P()", [this$.Zähler, this$.Nenner]));
    }
    get Ausdruck() {
        const this$ = this;
        return new Ausdruck(3, [AusdruckModule_ofInt(this$.Zähler), AusdruckModule_ofInt(this$.Nenner)]);
    }
}

export function Bruch_$reflection() {
    return record_type("MatheApp.Domain.Bruch", [], Bruch, () => [["Zähler", int32_type], ["Nenner", int32_type]]);
}

export function Bruch_Create_Z37302880(zähler, nenner) {
    if (nenner === 0) {
        throw new Exception("Nenner darf nicht 0 sein.\\nParameter name: nenner");
    }
    return new Bruch(zähler, nenner);
}

export function Bruch__GetGgt(this$) {
    const gcd = (a_mut, b_mut) => {
        gcd:
        while (true) {
            const a = a_mut, b = b_mut;
            if (b === 0) {
                return a | 0;
            }
            else {
                a_mut = b;
                b_mut = (a % b);
                continue gcd;
            }
            break;
        }
    };
    return gcd(Math.abs(this$.Zähler), Math.abs(this$.Nenner)) | 0;
}

export function Bruch__Kürzen(this$) {
    const ggt = Bruch__GetGgt(this$) | 0;
    return new Bruch(~~(this$.Zähler / ggt), ~~(this$.Nenner / ggt));
}

export function Bruch__IstGekürzt(this$) {
    return Bruch__GetGgt(this$) === 1;
}

export function Bruch__IstKürzbarMit_Z524259A4(this$, faktor) {
    if ((faktor > 1) && ((this$.Zähler % faktor) === 0)) {
        return (this$.Nenner % faktor) === 0;
    }
    else {
        return false;
    }
}

export function Bruch__ToDecimal(this$) {
    return op_Division(new Decimal(this$.Zähler), new Decimal(this$.Nenner));
}

export function Bruch_ErstelleZufälligenDezimalBruch_Z6EA5070B(random) {
    const nenners = ofArray([10, 100, 1000]);
    const nenner = item(random.Next1(length(nenners)), nenners) | 0;
    return Bruch_Create_Z37302880(random.Next2(1, nenner), nenner);
}

export function Bruch_ErstelleZufälligenBruch_ZC341D2B(random, min, max) {
    const min_1 = defaultArg(min, 2) | 0;
    const max_1 = defaultArg(max, 20) | 0;
    const primes = ofArray([2, 3, 5, 7, 11]);
    const gekuerzterBruch = Bruch__Kürzen(Bruch_Create_Z37302880(random.Next2(min_1, max_1), random.Next2(min_1, max_1)));
    let faktor;
    let selectedPrimes;
    const list_1 = filter((_arg) => (random.NextDouble() < 0.5), primes);
    selectedPrimes = truncate(random.Next2(1, 4), list_1);
    faktor = (equals(selectedPrimes, empty()) ? 2 : reduce((x, y) => ((x * y) | 0), selectedPrimes));
    const faktor_1 = ((faktor > 100) ? ~~(faktor / find((p) => ((faktor % p) === 0), primes)) : faktor) | 0;
    return Bruch_Create_Z37302880(gekuerzterBruch.Zähler * faktor_1, gekuerzterBruch.Nenner * faktor_1);
}

export function Bruch_get_Default() {
    return new Bruch(0, 1);
}

export class BruchEditable extends Record {
    constructor(Zähler, Nenner) {
        super();
        this.Zähler = Zähler;
        this.Nenner = Nenner;
    }
    get Ausdruck() {
        const this$ = this;
        return new Ausdruck(3, [AusdruckModule_get(this$.Zähler), AusdruckModule_get(this$.Nenner)]);
    }
}

export function BruchEditable_$reflection() {
    return record_type("MatheApp.Domain.BruchEditable", [], BruchEditable, () => [["Zähler", Editable$2_$reflection(int32_type, IntInput_$reflection())], ["Nenner", Editable$2_$reflection(int32_type, IntInput_$reflection())]]);
}

export function BruchEditable_OfBruch_63F776FF(bruch) {
    return new BruchEditable(new Editable$2(1, [bruch.Zähler]), new Editable$2(1, [bruch.Nenner]));
}

export function BruchEditable_get_Empty() {
    return new BruchEditable(new Editable$2(0, []), new Editable$2(0, []));
}

